// extracted by mini-css-extract-plugin
export default {"bio":"bio_bio__+jKgS","largeBio":"bio_largeBio__J1OKi","logo":"bio_logo__pg2A6","largeBioText":"bio_largeBioText__cnLUS"};